import { dasherize as emberDasherize } from "@ember/string";
export default function dasherize() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return emberDasherize(value.replace(".", "-"));
}